module.exports = __webpack_public_path__ + "img/nz.nzc13a64e.svg";